export interface FormValues {
  email: string;
  password: string;
  oneTimeCode?: string;
  emailAddress?: string;
  newPassword?: string;
}

export enum DeviceTypes {
  WEB_VIEW = "web_view",
  // Member portal loaded inside the clinician portal's "Member portal" iframe
  // (the EHR/EMR embed). Set at /auth/iframe and persisted on the session.
  IFRAME = "iframe",
}
